import React, { useState, useCallback } from 'react';
import cx from 'classnames';
import { Text, Link, Input, Button } from '../../../../../ui-kit';
import '../styles/_payment-section.scss';












function PaymentSectionFooter({
  prefixDagger,
  footerStartAdornment,
  footerTotalText,
  footerTotalValue,
  isFooterTotalValueChangeable,
  footerTotalValuePlaceholder,
  onFooterTotalValueChange,
  className
}) {
  const [totalValue, setTotalValue] = useState(footerTotalValue);
  const [showTotalValueForm, setShowTotalValueForm] = useState(false);

  const handleClickUpdateLink = useCallback(() => {
    setShowTotalValueForm(true);
  }, []);

  const handleClickCancelButton = useCallback(() => {
    setTotalValue(footerTotalValue);
    setShowTotalValueForm(false);
  }, [footerTotalValue]);

  const handleClickSaveButton = useCallback(() => {
    setShowTotalValueForm(false);
    if (totalValue !== footerTotalValue && onFooterTotalValueChange) {
      onFooterTotalValueChange(totalValue);
    }
  }, [totalValue, footerTotalValue]);

  return (
    <div className={cx('payment-section__footer', className)}>
      {footerStartAdornment &&
      <div className="payment-section__footer-start-adornment">
          <Text prefixDagger={prefixDagger} className="payment-section__footer-start-adornment-text" noMargin>
            {footerStartAdornment}
          </Text>
        </div>}

      <div className="payment-section__footer-spacer" />

      <div className="payment-section__footer-total-block">
        <Text className="payment-section__footer-total-text" noMargin heading5>
          {footerTotalText}
        </Text>

        <Text className="payment-section__footer-total-value" heading4 noMargin>
          {!isFooterTotalValueChangeable ?
          footerTotalValue :

          <>
              {showTotalValueForm ?
            <div className="payment-section__footer-total-value__update-form">
                  <Input
                className="payment-section__footer-total-value__update-form__input"
                value={totalValue}
                defaultValue={totalValue}
                onChange={(event) => setTotalValue(event.target.value)}
                placeholder={footerTotalValuePlaceholder} />

                  <div className="payment-section__footer-total-value__update-form__button-container">
                    <Button
                  type="TERTIARY"
                  className="payment-section__footer-total-value__update-form__button-container__button"
                  onClick={handleClickCancelButton}>

                      Cancel
                    </Button>
                    <Button
                  type="SECONDARY"
                  className="payment-section__footer-total-value__update-form__button-container__button"
                  onClick={handleClickSaveButton}>

                      Confirm & Save
                    </Button>
                  </div>
                </div> :

            <>
                  <Link
                className="payment-section__footer-total-value__update-link"
                onClick={handleClickUpdateLink}>

                    Update
                  </Link>
                  {totalValue || 'None'}
                </>}

            </>}

        </Text>
      </div>
    </div>);

}

export default PaymentSectionFooter;